// Libs
import { Request } from "@collectivehealth/cog";
import { getUrlHostParts } from "utils/env";

export default class UrlSponsor {
  constructor(data) {
    this.data = data;
  }

  /**
   * @returns {number}
   */
  get id() {
    return this.data.id;
  }

  /**
   * @returns {string}
   */
  get name() {
    return this.data.name;
  }

  /**
   * @returns {string}
   */
  get sponsorCode() {
    return this.data.sponsorCode;
  }

  /**
   * Gets the sponsor name from the URL
   * @return {string}
   */
  static get urlSponsorName() {
    return getUrlHostParts()[0];
  }

  /**
   * Gets a single instance of the model
   * @return {UrlSponsorModel}
   */
  static async getSingle() {
    const response = await Request.get(`/api/v1/sponsor/url_name/${this.urlSponsorName}`);

    return new this(response);
  }
}
